enum UpdateLeadTypeEnum {
    ApprovePrivateListingAccess = 'Approve private listing access',
    DenyPrivateListingAccess = 'Deny private listing access',
}

export default UpdateLeadTypeEnum;
